import request from '@/utils/request';

// 客户
export function clientList(params) {
  return request({ url: `/custom/getList`, method: 'get', params })
}
export function assetList(params) {
  return request({ url: `/custom/asset/getList`, method: 'get', params })
}
export function tradeList(params) {
  return request({ url: `/custom/trade/getList`, method: 'get', params })
}
export function clientCreate(data) {
  return request({ url: `/custom/`, method: 'post', data })
}

export function clientUpdate(data) {
  return request({ url: `/custom/${data.id}/`, method: 'put', data })
}
export function sStart(data) {
  return request({ url: `/custom/isActive/start`, method: 'post', data })
}
export function sStop(data) {
  return request({ url: `/custom/isActive/stop`, method: 'post', data })
}
export function clientDestroy(data) {
  return request({ url: `/custom/delete`, method: 'post', data })
}


